import { useTranslations } from 'next-intl';
import { ReactNode } from 'react';

import { ArticleI } from 'types/article';

export interface ArticlePremiumContentPercentageLabels {
  textPercentage: string;
  loginPrompt: ReactNode;
}

interface ArticlePremiumContentPercentageProps {
  article: ArticleI;
}
export default function ArticlePremiumContentPercentage({ article }: ArticlePremiumContentPercentageProps) {
  const percentage = calculatePercentage(article);

  return <ArticlePremiumContentPercentageSimple percentage={percentage} />;
}

export function calculatePercentage(article: ArticleI) {
  const beforeContent = article.beforeContent;
  const content = article.content;
  const payContent = article.payContent;
  const freeContentLength = beforeContent.length + (content?.length || 0);
  const payContentLength = payContent?.length || 0;

  return Math.min(90, Math.ceil((payContentLength / (freeContentLength + payContentLength)) * 100));
}

export function ArticlePremiumContentPercentageSimple({ percentage }: { percentage: number }) {
  const tPremium = useTranslations('premium');
  const percentageText = tPremium('contentCover.textPercentage', {
    percentage: '[percentage]',
  }).replace('[percentage]', percentage.toString());

  return (
    <div className="absolute z-10 flex h-full w-full flex-col items-center justify-center text-lg font-bold text-premium-900 lg:text-2xl dark:text-white">
      <p className="text-center">{percentageText}</p>
    </div>
  );
}
